/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";
// core components

function LilithHeader() {
  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });

  return (
    <>
      <div className="page-header clear-filter">
        <img
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/lilith-1b.webp") + ")"
          }}
          ref={pageHeader}
        ></img>
        <Container>
          <div className="content-center brand">
          </div>
        </Container>
      </div>
    </>
  );
}

export default LilithHeader;
